import React from 'react';

const Banner = () => {
    return (
        <section className="md:flex md:justify-between md:py-36">
          <div className="w-1/2">
            <p className="text-red-500 mb-6">I am Amit Kumar</p>
            <h1 className="text-white text-4xl font-extrabold mb-10">
              Web Developer
            </h1>
            <a href="Resume of Amit.pdf" download={"Resume of Amit"}>
              <button className="bg-white text-red-500 font-[Poppins] duration-500 px-6 py-2 hover:bg-red-500 hover:text-white rounded">
                Download Resume
              </button>
            </a>
          </div>
          <div className="text-center w-1/2">
            <iframe
              title="Lottie Animation"
              className="inline-block w-60 h-60"
              src="https://embed.lottiefiles.com/animation/109119"
            ></iframe>
          </div>
        </section>
    );
};

export default Banner;